import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ElementRef,
  HostBinding,
  HostListener
} from '@angular/core';

@Component({
  selector: 'app-machine-card',
  templateUrl: './machine-card.component.html',
  styleUrls: ['./machine-card.component.scss'],
})
export class MachineCardComponent implements OnInit {

  // deleteMachineCheckbox is used to pass the checked item from component to machine mgmt page
  @Output() deleteMachineCheckbox = new EventEmitter<string>();
  @Output() checkMore = new EventEmitter<string>();
  @Input() item: any;
  @Input() showStatus: boolean;
  @Input() showMore: boolean;
  @Input() showCheckbox: boolean;
  @Input() status: any;

  // Make every <app-machine-card> focusable via keyboard
  @HostBinding('attr.tabindex') hostTabIndex = 0;
  @HostBinding('attr.role') hostRole = 'button';

  constructor(private readonly hostEl: ElementRef<HTMLElement>) { }

  ngOnInit() {}

  // Enter/Space on card should behave like mouse click on card
  @HostListener('keydown', ['$event'])
  onHostKeydown(event: KeyboardEvent): void {
    const key = event.key;
    if (key !== 'Enter' && key !== ' ') {
      return;
    }

    const target = event.target as HTMLElement | null;

    // Let child interactive controls handle keyboard themselves.
    // Do not include [role="button"] here because the host itself has that role.
    if (target?.closest('ion-checkbox,button,a,input,textarea,select,ng-select')) {
      return;
    }

    event.preventDefault();
    this.hostEl.nativeElement.click();
  }

  // To prevent the propagation of current event i.e. checkbox check/uncheck on the card
  public stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  // Keyboard toggle for checkbox (same as mouse click)
  public onCheckboxKeydown(event: KeyboardEvent): void {
    const key = event.key;
    if (key !== 'Enter' && key !== ' ') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement | null)?.click();
  }

  // To pass the selected checkbox item to the parent component
  public changeMachineCheckboxSelection(event: any, item: any): void {
    item.isChecked = event?.detail?.checked;
    this.deleteMachineCheckbox.emit(item);
  }

  // To pass the selected item to the parent component on clicking ellipsis icon
  public clickMore(ev: any): void {
    ev?.stopPropagation?.();
    this.checkMore.emit(ev);
  }
}
